import React, { useState, useEffect, useRef } from 'react';
import { Tag } from 'primereact/tag';


export default function TagInativo(props){

    return <Tag severity="danger" value="INATIVO" style={{cursor :'pointer'}}></Tag>
}